import { getIntlDisplayNames } from "../i18n.ts";

class Currency{
  constructor(code,name){
    this.code = code;
    this.name = name;
  }
}

function listAllCurrency(lang){
  const 
    currencyNames = getIntlDisplayNames(lang,'currency'),
    result = [];
  
  Intl.supportedValuesOf('currency').filter(code=>code!=='XSU').forEach(code=>{
    result.push(new Currency(code,currencyNames.of(code)))
  });
  result.sort((a,b)=>a.name.localeCompare(b.name))
  return result;
}

function getByCurrencyCode(lang,code){
  const 
    currencyNames = getIntlDisplayNames(lang,'currency');
  
  return new Currency(code,currencyNames.of(code)) 
}

export {listAllCurrency,getByCurrencyCode}